// Layout.js
import React from 'react';
import { Box } from '@mui/material';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Header />
      <Box sx={{ display: 'flex', flexGrow: 1, pt: '64px' }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 3, }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;